import { useEffect, useState } from 'react';

/**
 * Detects render mode: phone | desk.
 * - Phone: width < 768 OR coarse pointer (touch device)
 * - Desk:  everything else
 *
 * Sets document.documentElement.dataset.mode so CSS [data-mode="..."]
 * selectors can scope phone-only rules.
 *
 * Override via ?mode=phone|desk for testing.
 */
function compute() {
  if (typeof window === 'undefined') return 'desk';

  try {
    const p = new URLSearchParams(window.location.search);
    const override = p.get('mode');
    if (override === 'phone' || override === 'desk') return override;
  } catch { /* noop */ }

  const coarse = window.matchMedia('(pointer: coarse)').matches;
  if (window.innerWidth < 768 || coarse) return 'phone';
  return 'desk';
}

export default function useRenderMode() {
  const [mode, setMode] = useState(() => compute());

  useEffect(() => {
    document.documentElement.dataset.mode = mode;
  }, [mode]);

  useEffect(() => {
    let t;
    const onResize = () => {
      clearTimeout(t);
      t = setTimeout(() => setMode(compute()), 250);
    };
    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('resize', onResize); clearTimeout(t); };
  }, []);

  return mode;
}
